import { addNotification, NotificationType } from '@vista-digital/occ-domain'
import type { FC } from 'react'
import { useState } from 'react'
import type { MemberPasswordResetFormProps } from '@/common/components/signInForm/memberPasswordResetForm/MemberPasswordResetForm'
import { MemberPasswordResetForm } from '@/common/components/signInForm/memberPasswordResetForm/MemberPasswordResetForm'
import { MemberSignInForm } from '@/common/components/signInForm/memberSignInForm/MemberSignInForm'
import type { MemberSignInFormPropsApi } from '@/common/components/signInForm/memberSignInForm/models'
import { movioTracker } from '@/common/services/movioTracker.service'

export interface SignInProps {
    signInFormDisplayText: MemberSignInFormPropsApi
    passwordResetFormDisplayText: MemberPasswordResetFormProps['displayText']
    onAfterSuccessfulSubmit?: () => void
    onPasswordResetSubmitted?: () => void
}

export const SignInForm: FC<SignInProps> = props => {
    const { signInFormDisplayText, passwordResetFormDisplayText, onPasswordResetSubmitted, onAfterSuccessfulSubmit } =
        props
    const [isPasswordReset, setIsPasswordReset] = useState(false)

    const showPasswordReset = () => setIsPasswordReset(true)
    const hidePasswordReset = () => setIsPasswordReset(false)

    if (isPasswordReset) {
        return (
            <MemberPasswordResetForm
                displayText={passwordResetFormDisplayText}
                memberSignInDisplayText={signInFormDisplayText}
                onNavigateToSignIn={hidePasswordReset}
                events={{
                    onAfterSuccessfulSubmit: () => {
                        hidePasswordReset()
                        addNotification({
                            id: 'password-reset-notification',
                            messages: [passwordResetFormDisplayText.resetConfirmationNotification],
                            type: NotificationType.Success,
                            autoDismiss: false,
                            actionButton: { show: false },
                            closeButton: { show: true },
                        })
                        onPasswordResetSubmitted?.()
                    },
                }}
            />
        )
    }

    return (
        <MemberSignInForm
            displayText={signInFormDisplayText}
            onNavigateToForgotPassword={showPasswordReset}
            events={{
                onAfterSuccessfulSubmit: () => {
                    onAfterSuccessfulSubmit?.()
                    void movioTracker.initiateLogin()
                },
            }}
        />
    )
}
